import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout/Layout';
import PublicLayout from './components/Public/PublicLayout';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';

// Public Pages
import Home from './components/Public/Home';
import Services from './components/Public/Services';
import About from './components/Public/About';
import Contact from './components/Public/Contact';
import Courts from './components/Public/Courts';

// Master Modules
import CourtMaster from './components/Master/CourtMaster';
import JudgeMaster from './components/Master/JudgeMaster';
import AdvocateMaster from './components/Master/AdvocateMaster';
import UserMaster from './components/Master/UserMaster';

// Case Management
import CaseRegistration from './components/CaseManagement/CaseRegistration';
import PartyDetails from './components/CaseManagement/PartyDetails';
import CaseAdvocateMapping from './components/CaseManagement/CaseAdvocateMapping';

// Hearing & Scheduling
import HearingScheduling from './components/Hearing/HearingScheduling';
import HearingProceedings from './components/Hearing/HearingProceedings';

// Document Management
import DocumentManagement from './components/Documents/DocumentManagement';

// Judgment & Order
import JudgmentOrder from './components/Judgment/JudgmentOrder';

// Cause List
import CauseList from './components/CauseList/CauseList';

// Case Status
import CaseStatusTracking from './components/CaseStatus/CaseStatusTracking';

// Notifications
import Notifications from './components/Notifications/Notifications';

// Reports
import Reports from './components/Reports/Reports';

// Admin
import AdminPanel from './components/Admin/AdminPanel';
import AuditLogs from './components/Admin/AuditLogs';

function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<Services />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="courts" element={<Courts />} />
            <Route path="case-status" element={<CaseStatusTracking />} />
          </Route>

          {/* Login Route */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes (Requires Login) */}
          <Route path="/app" element={<Layout />}>
            <Route index element={<Navigate to="/app/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            
            {/* Master Modules */}
            <Route path="master/court" element={<CourtMaster />} />
            <Route path="master/judge" element={<JudgeMaster />} />
            <Route path="master/advocate" element={<AdvocateMaster />} />
            <Route path="master/user" element={<UserMaster />} />
            
            {/* Case Management */}
            <Route path="case/registration" element={<CaseRegistration />} />
            <Route path="case/party-details" element={<PartyDetails />} />
            <Route path="case/advocate-mapping" element={<CaseAdvocateMapping />} />
            
            {/* Hearing & Scheduling */}
            <Route path="hearing/scheduling" element={<HearingScheduling />} />
            <Route path="hearing/proceedings" element={<HearingProceedings />} />
            
            {/* Document Management */}
            <Route path="documents" element={<DocumentManagement />} />
            
            {/* Judgment & Order */}
            <Route path="judgment" element={<JudgmentOrder />} />
            
            {/* Cause List */}
            <Route path="cause-list" element={<CauseList />} />
            
            {/* Case Status */}
            <Route path="case-status" element={<CaseStatusTracking />} />
            
            {/* Notifications */}
            <Route path="notifications" element={<Notifications />} />
            
            {/* Reports */}
            <Route path="reports" element={<Reports />} />
            
            {/* Admin */}
            <Route path="admin" element={<AdminPanel />} />
            <Route path="admin/audit-logs" element={<AuditLogs />} />
          </Route>
        </Routes>
      </Router>
    </AppProvider>
  );
}

export default App;

